export default "__VITE_ASSET__CDKSvPFs__"